import React from "react"

import { Input, SettingRow, Switch } from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"
import type { WebSocketFieldProps } from "./types"

interface HandshakeFieldsProps extends WebSocketFieldProps {
  isHttpFirst: boolean
}

export const HandshakeFields: React.FC<HandshakeFieldsProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
  isHttpFirst,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Handshake</h4>

      <div className="space-y-2">
        <FieldLabel
          htmlFor="ready-message-type"
          tooltip={
            isHttpFirst
              ? `${WEBSOCKET_TOOLTIPS.readyMessageType} In HTTP setup mode, you can leave this empty to start immediately.`
              : WEBSOCKET_TOOLTIPS.readyMessageType
          }
        >
          Ready Message Type
        </FieldLabel>
        <Input
          id="ready-message-type"
          aria-label="Ready Message Type"
          value={metadata.handshake_ready_message_type || ""}
          placeholder="Enter the ready message type"
          onChange={(e) =>
            onMetadataUpdate({
              handshake_ready_message_type: e.target.value,
            })
          }
          disabled={disabled}
        />
      </div>

      <SettingRow
        label="Require Session ID"
        tooltip={WEBSOCKET_TOOLTIPS.requireSessionId}
      >
        {(controlId) => (
          <Switch
            id={controlId}
            checked={metadata.handshake_requires_session_id !== false}
            onCheckedChange={(checked) =>
              onMetadataUpdate({ handshake_requires_session_id: checked })
            }
            disabled={disabled}
          />
        )}
      </SettingRow>

      <div className="space-y-2">
        <FieldLabel
          htmlFor="handshake-timeout"
          tooltip={WEBSOCKET_TOOLTIPS.handshakeTimeout}
        >
          Handshake Timeout (seconds)
        </FieldLabel>
        <Input
          id="handshake-timeout"
          aria-label="Handshake Timeout"
          type="number"
          placeholder="Set a handshake timeout in seconds"
          min={1}
          value={
            metadata.handshake_timeout_seconds != null
              ? String(metadata.handshake_timeout_seconds)
              : ""
          }
          onChange={(e) => {
            const raw = e.target.value
            if (raw === "") {
              onMetadataUpdate({
                handshake_timeout_seconds: undefined,
              })
            } else {
              const parsed = parseInt(raw, 10)
              if (!isNaN(parsed)) {
                onMetadataUpdate({
                  handshake_timeout_seconds: parsed,
                })
              }
            }
          }}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
